enum VariantButton {
  General = "General",
  Transparent = "Transparent",
  Red = "Red",
  RedTransparent = "RedTransparented",
  GreenTransparent = "GreenTransparent"
}

export default VariantButton;
